export default getRefs=()=>{
    return {
        form:document.querySelector('#search-form'),
        loadMoreBtn:document.querySelector('.load-more'),
        gallery:document.querySelector('.gallery'),
        upBtn:document.querySelector('.up')
    }
}